import { render, staticRenderFns } from "./DealsTable.vue?vue&type=template&id=77ba946a&scoped=true&lang=pug&"
import script from "./DealsTable.vue?vue&type=script&lang=js&"
export * from "./DealsTable.vue?vue&type=script&lang=js&"
import style0 from "./DealsTable.vue?vue&type=style&index=0&id=77ba946a&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77ba946a",
  null
  
)

export default component.exports